import { Button } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React from 'react';

import type { ServicePointsTableData } from './types';

export const getServicePointsTableColumns = (
  handleEditButtonClick: (record: ServicePointsTableData) => void
) => {
  const columns: ColumnsType<ServicePointsTableData> = [
    {
      title: '服務',
      dataIndex: 'serviceName',
    },
    {
      title: '點數功能開/關',
      dataIndex: 'isActive',
      render: (value) => (value ? '開' : '關'),
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: 100,
      fixed: 'right',
      render: (_, record) => {
        return (
          <Button onClick={() => handleEditButtonClick(record)}>編輯</Button>
        );
      },
    },
  ];
  return columns;
};
